const ACTIVE_ACCESS = new Set(['trial_active', 'active_paid']);

function isBillingAccessActive(access) {
    return ACTIVE_ACCESS.has(access?.access_status);
}

module.exports = { isBillingAccessActive };
